<span class="pill" [ngClass]="pillColorStyle">{{ count }}</span>
